<ul class="pill-group" *ngIf="!pills">
  <ng-container *ngFor="let pill of pills$ | async; let i = index">
    <li id="pill-{{ i }}" class="pill">
      <a
        id="pill-link-{{ i }}"
        (click)="onClicked(pill)"
        (focus)="onFocus(i)"
        (keydown.enter)="OnKeyDownEnter(i, pill)"
        tabindex="0"
        #pillsList
        >{{ pill.text }}
        <nibtravel-icon spacing="space-left" icon="close"></nibtravel-icon>
      </a>
    </li>
  </ng-container>
</ul>
